import { createIsomorphicFn } from "@tanstack/react-start";
import { getCookie } from "@tanstack/react-start/server";

export const getThemeIsomorphic: () => Promise<"dark" | "light"> = createIsomorphicFn()
  .server(async () => {
    return getCookie("theme") === "light" ? "light" : "dark";
  })
  .client(async () => {
    return document.cookie.includes("theme=light") ? "light" : "dark";
  });
